import {Graphics, InteractionEvent, Text} from 'pixi.js';
import {TextFactory} from '../../../../../../factories/TextFactory';
import {Pivot} from '../../../../../../utils/Pivot';
import {StaticData} from '../../../../../../data/StaticData';
import {HoverableObject} from '../../../../../../base/HoverableObject';
import {PointsButtons} from './points_counter/PointsButtons';

export class PointsCounter extends HoverableObject
{
    pointsButtons: PointsButtons;
    graphicsBg: Graphics;
    valueText: Text;

    constructor(playerId: string) {
        super();

        this.pointsButtons = new PointsButtons(playerId);

        this.graphicsBg = new Graphics();
        this.updateColor();

        this.valueText = TextFactory.create('', 24, 0);

        this.addChild(this.pointsButtons);
        this.addChild(this.graphicsBg);
        this.addChild(this.valueText);

        this.value = 0;
    }

    set value(val: number) {
        this.valueText.text = val + '';

        Pivot.centerPivot(this.valueText);
        this.pointsButtons.value = val;
    }

    updateColor(): void {
        this.graphicsBg.clear();
        this.graphicsBg.beginFill(0xffffff);
        this.graphicsBg.drawCircle(0, 0, StaticData.videoSeatPointsCounterRadius);
        this.graphicsBg.endFill();
    }

    /**
     * Обработчик события pointerover
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerOver(e: InteractionEvent): void {
        this.pointsButtons.appear();
    }

    /**
     * Обработчик события pointerout
     * @param e Событие взаимодейтсвия пользователя
     */
    onPointerOut(e?: InteractionEvent): void {
        this.pointsButtons.appear(false);
    }
}
